import { render, staticRenderFns } from "./ColumnInfoForm.vue?vue&type=template&id=58629da4&"
import script from "./ColumnInfoForm.vue?vue&type=script&lang=js&"
export * from "./ColumnInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports